<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b"><a id="page_7"></a>Contents</h2>
<p class="toc"><a class="nounder" href="#/xhtml/intro#intro">Introduction</a></p>
<p class="toc"><a class="nounder" href="#/xhtml/ch01#ch01">On Generalship</a></p>
<p class="toc"><a class="nounder" href="#/xhtml/ch02#ch02">Union Generals</a></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">Confederate Generals</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">Composite Quotes</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/appa#appa" title="Link target outside of Sample">Appendix A: Maps</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/appb#appb" title="Link target outside of Sample">Appendix B: The Contributors</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/appc#appc" title="Link target outside of Sample">Appendix C: The Battles</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/biblio#biblio" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/index#index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?77e1bbb8